<img [src]="url" alt="Imagen ampliada" class="dialog-img">